import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, MoneyInput, NumberInput } from "../../components/forms/Inputs"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"

function OffreMaterielDetailFields({ item, set, tab }) {
    const t = useTranslations()
    const articleOptions = useOptions('articles', 'nom')

    const changeArticle = (id, item) => {
        set('articleId')(id)
        if (id) set('prix')(item.prixVente)
    }

    return <>
        <Row>
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} required />
            <AsyncSelect className="grow" label={t("Article")} value={item.articleId} onChange={changeArticle} options={articleOptions} required />
            <NumberInput label={t("Nombre")} value={item.nbr} onChange={set('nbr')} required />
            <MoneyInput label={t("Prix")} value={item.prix} onChange={set('prix')} required />
        </Row>
    </>
}

export function OffreMaterielDetailsList(props) {
    const t = useTranslations()
    return <ListPage model="offreMaterielDetail" title={t("Détail")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Article')]: { sort: 'article', value: item => <FkLink>{item.article?.nom}</FkLink> },
        [t('Nombre')]: 'nbr',
        [t('Prix')]: 'prix',
    }} join={{
        article: 'nom',
    }} {...props} />
}

export function OffreMaterielDetailDetail(props) {
    const t = useTranslations()
    return <DetailPage model="offreMaterielDetail" title={t("Détail")} Fields={OffreMaterielDetailFields} {...props} />
}
